
function PlaySVG() {
  return (
    <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M0.440918 0.875L10.4752 7L0.440918 13.125V0.875ZM1.31346 2.43184V11.5679L8.79704 7L1.31346 2.43184Z" fill="black"/>
    </svg>
  )
}

export { PlaySVG }